import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-340fb9ad")

_pushScopeId("data-v-340fb9ad")
const _hoisted_1 = { class: "p-d-flex p-flex-row" }
const _hoisted_2 = { class: "table-header p-d-flex p-ai-center" }
const _hoisted_3 = {
  id: "search-container",
  class: "p-input-icon-left p-mr-3"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_5 = {
  key: 0,
  class: "kn-flex"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Chip = _resolveComponent("Chip")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_GlossaryUsageLinkTree = _resolveComponent("GlossaryUsageLinkTree")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_component_Card, null, {
    header: _withId(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
        start: _withId(() => [
          _createTextVNode(_toDisplayString(_ctx.title), 1)
        ]),
        end: _withId(() => [
          _createVNode(_component_Button, {
            class: "kn-button p-button-text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
          }, {
            default: _withId(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.close')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    content: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          value: _ctx.items,
          id: "link-table",
          class: "p-datatable-sm kn-table p-mr-3",
          selection: _ctx.selectedItem,
          "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => (_ctx.selectedItem = $event)),
          selectionMode: "single",
          expandedRows: _ctx.expandedRows,
          "onUpdate:expandedRows": _cache[6] || (_cache[6] = ($event: any) => (_ctx.expandedRows = $event)),
          loading: _ctx.loading,
          dataKey: "id",
          filters: _ctx.filters,
          "onUpdate:filters": _cache[7] || (_cache[7] = ($event: any) => (_ctx.filters = $event)),
          globalFilterFields: _ctx.glossaryUsageLinkCardDescriptor.globalFilterFields,
          paginator: true,
          rows: 20,
          responsiveLayout: "stack",
          breakpoint: "960px",
          onRowSelect: _ctx.onRowExpand,
          onRowExpand: _ctx.onRowExpand
        }, {
          header: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("span", _hoisted_3, [
                _hoisted_4,
                _createVNode(_component_InputText, {
                  class: "kn-material-input",
                  modelValue: _ctx.filters['global'].value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filters['global'].value = $event)),
                  type: "text",
                  placeholder: _ctx.$t('common.search')
                }, null, 8, ["modelValue", "placeholder"])
              ])
            ])
          ]),
          empty: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          loading: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.dataLoading')), 1)
          ]),
          expansion: _withId((slotProps) => [
            _createVNode("div", {
              style: _ctx.glossaryUsageLinkCardDescriptor.dropZoneStyle,
              onDrop: ($event: any) => (_ctx.onDragDrop($event, slotProps.data)),
              onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
              onDragenter: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"]))
            }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.associatedWords[slotProps.data.id], (word) => {
                return (_openBlock(), _createBlock(_component_Chip, {
                  class: "p-m-2",
                  key: word.WORD_ID,
                  label: word.WORD
                }, {
                  default: _withId(() => [
                    _createVNode("span", null, _toDisplayString(word.WORD), 1),
                    _createVNode("i", {
                      class: "pi pi-times-circle chip-icon p-ml-3",
                      onClick: ($event: any) => (_ctx.deleteWordConfirm(word.WORD_ID, slotProps.data))
                    }, null, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1032, ["label"]))
              }), 128))
            ], 44, ["onDrop"])
          ]),
          default: _withId(() => [
            _createVNode(_component_Column, {
              expander: true,
              headerStyle: _ctx.glossaryUsageLinkCardDescriptor.expanderHeaderStyle
            }, null, 8, ["headerStyle"]),
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.glossaryUsageLinkCardDescriptor.columns, (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                class: "kn-truncated",
                field: col.field,
                header: _ctx.$t(col.header),
                key: col.field,
                sortable: true
              }, null, 8, ["field", "header"]))
            }), 128)),
            (_ctx.showModelColumn)
              ? (_openBlock(), _createBlock(_component_Column, {
                  key: 0,
                  class: "kn-truncated",
                  field: "model",
                  header: 'model',
                  sortable: true
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["value", "selection", "expandedRows", "loading", "filters", "globalFilterFields", "onRowSelect", "onRowExpand"]),
        (_ctx.selectedItem && _ctx.selectedItem.id && _ctx.selectedItem.itemType !== 'document')
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary" }, {
                start: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('managers.glossary.glossaryUsage.column')), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_GlossaryUsageLinkTree, {
                treeWords: _ctx.associatedWordsTree[_ctx.selectedItem.id],
                onDelete: _ctx.deleteTreeWord,
                onWordDropped: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onDragDrop($event.event, $event.item)))
              }, null, 8, ["treeWords", "onDelete"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
})